import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Box } from 'foundations-components/transitional/components/Box';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import LearnMoreModalListItem from '../base/LearnMoreModalListItem';
import LearnMoreModal from '../base/LearnMoreModal';
import { useModalTracker } from '../../../hooks/tracking';
import { KNOWLEDGE_BASE_INSTALL_SALES_URL } from '../../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InstallSalesExtensionModal = ({
  onClose
}) => {
  const {
    trackLink
  } = useModalTracker('InstallSalesExtensionModal');
  return /*#__PURE__*/_jsxs(LearnMoreModal, {
    footer: /*#__PURE__*/_jsx(KnowledgeBaseButton, {
      onClick: () => trackLink('install sales extension article'),
      url: KNOWLEDGE_BASE_INSTALL_SALES_URL,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.readInstructions"
      })
    }),
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.modal.installSalesExtension.heading"
    }),
    illustrationName: "templates",
    onClose: onClose,
    children: [/*#__PURE__*/_jsx(Box, {
      marginBlockEnd: "500",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.installSalesExtension.description"
      })
    }), /*#__PURE__*/_jsx(LearnMoreModalListItem, {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "setup-guide-components.modal.installSalesExtension.li1"
      })
    }), /*#__PURE__*/_jsx(LearnMoreModalListItem, {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "setup-guide-components.modal.installSalesExtension.li2"
      })
    }), /*#__PURE__*/_jsx(LearnMoreModalListItem, {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "setup-guide-components.modal.installSalesExtension.li3"
      })
    }), /*#__PURE__*/_jsx(LearnMoreModalListItem, {
      message: "setup-guide-components.modal.installSalesExtension.li4"
    })]
  });
};
InstallSalesExtensionModal.propTypes = {
  onClose: PropTypes.func
};
export default InstallSalesExtensionModal;